import { Accordion, Button, HeroBackground, ProductMain, useWindowWidth } from '@prishapolicy/shared/ui';
import Image from 'next/image';
import HeroImage from './hero-image.png';

import { WhoChoosesThis } from '@prishapolicy/w3/ui';
import { NextSeo } from 'next-seo';

const pristynLink = 'https://www.pristyncare.com/gp/partners-Prisha';

const MedicalServices = () => {
  const accordionData = [
    {
      name: 'Proctology',
      arrayData: [
        'Pilonidal Sinus',
        'Piles',
        'Rectal Prolapse',
        'Fissure',
        'Fistula',
        'FecalIncontinence',
        'Constipation',
        'Hemorrhoids',
      ],
    },
    {
      name: 'Laparoscopy',
      arrayData: [
        'Umbilical Hernia',
        'Hydrocele',
        'Inguinal Hernia',
        'Incisional Hernia',
        'Appendicitis',
        'Gallstone',
        'Hernia',
        'Achalasia Cardia',
        'Acid Reflux Surgery',
        'Large Intestine',
        'Indirect Hernia',
        'Small Intestine',
      ],
    },
    {
      name: 'Gynaecology',
      arrayData: [
        'Pain During Intercourse',
        'Vaginoplasty',
        'Labiaplasty',
        'Vaginal Discharge',
        'Laser Vaginal Tightening',
        'Vaginal Dryness',
        'Ovarian Cyst',
        'Hysterectomy',
        'Hymenoplasty',
        'Clitoral Hoodoplasty',
        'Abortion',
        'Hysteroscopy',
        'Pap Smear',
        'Vaginal Rejuvenation',
        'Ectopic Pregnancy',
        'Laser Vaginal Rejuvenation',
        'Vaginal Recurrent Infection',
        'Pelvic Pain',
        'Female Urinary Problems',
        'Lichen Sclerosus',
        'Menstrual Disorders',
        'Preconception Care',
        'Uterine Fibroid',
        'Pcos Pcod',
        'Pregnancy Care',
        'Medical Termination Of Pregnancy',
        'Laser Vaginal Bleaching',
        'Anal Bleaching',
        'Vaginal Wart',
        'Molar Pregnancy',
        'Bartholin Cyst',
        'Miscarriage',
        'Endometriosis',
        'Adenomyosis',
      ],
    },
    {
      name: 'ENT',
      arrayData: [
        'Turbinate Reduction',
        'Uvulopalatopharyngoplasty',
        'Adenoidectomy',
        'Myringotomy',
        'Microlaryngeal',
        'Mastoidectomy',
        'Tongue Base Reduction',
        'Tonsils Removal',
        'Middle Ear Perforation',
        'Deviated Nasal Septum',
        'Eardrum Surgery',
        'Sinus Surgery',
        'Thyroidectomy',
      ],
    },
    {
      name: 'Urology',
      arrayData: [
        'Urinary Tract Infection',
        'Urinary Incontinence',
        'Erectile Dysfunction',
        'Urethral Stricture',
        'Stress Urinary Incontinence',
        'Circumcision',
        'Kidney Stones',
        'Male Urinary Tract Infection',
        'Prostate Enlargement',
        'Vascular',
        'Varicose Veins',
        'Varicocele',
        'Diabetic Foot Ulcer',
        'AV Fistula For Dialysis',
        'Deep Vein Thrombosis',
        'Spider Veins',
        'Aesthetics',
        'Gynecomastia',
        'Liposuction',
        'Lipoma',
        'Hair Transplant',
        'Sebaceous Cyst',
        'Breast Lift',
        'Rhinoplasty',
        'Breast Reduction',
        'Breast Augmentation',
        'Breast Lump',
        'Hair Loss',
        'Breast Surgery',
        'Axillary Breast',
        'Scar Removal',
        'Abdominoplasty',
      ],
    },
    {
      name: 'Orthopedics',
      arrayData: [
        'Carpal Tunnel Syndrome',
        'Knee Replacement',
        'Spine Surgery',
        'Hip Replacement',
        'Arthroscopy',
        'ACL Tear',
        'Rotator Cuff Repair',
        'Bankart Surgery',
        'Bankart Repair',
        'Meniscus Repair Surgery',
        'Shoulder Replacement Surgery',
      ],
    },
    {
      name: 'Ophthalmology',
      arrayData: [
        'Lasik',
        'Cataract',
        'Squint Surgery',
        'Glaucoma Surgery',
        'Retinal Detachment Surgery',
        'Diabetic Retinopathy Treatment',
        'Intravitreal Injections',
      ],
    },
    {
      name: 'Fertility',
      arrayData: ['Male Infertility', 'Female Infertility', 'Ivf', 'Iui'],
    },
    {
      name: 'Dental',
      arrayData: ['Teeth Alignment (Fix)', 'Dental Others'],
    },
  ];
  return (
    <div className="mt-18">
      <div className="text-title-3 mb-7 font-bold">Medical Services Covered</div>
      <div className="flex flex-col gap-2">
        <Accordion
          showIcon={false}
          list={accordionData.map((d) => {
            return {
              question: d.name,
              answer: d.arrayData.map((v, idx) => (
                <div key={idx} className="py-1">
                  {v}
                </div>
              )),
            };
          })}
        />
      </div>
    </div>
  );
};
const Consultation = () => {
  return (
    <div className="bg-teal-300 ">
      <div className="py-15 mt-18 container flex flex-col gap-4 lg:flex-row lg:items-center lg:gap-8">
        <div className="lg:text-title-2 text-title-5 flex-grow font-bold">Book your free consultation today!</div>
        <Button text="Schedule a Free Consultation" rightIcon="arrowRight" onClick={() => window.open(pristynLink)} />
        <Button
          text="Schedule a Second Opinion"
          rightIcon="arrowRight"
          variant="secondary"
          onClick={() => window.open(pristynLink)}
        />
      </div>
    </div>
  );
};
const Stats = ({ statsNumber, text }: { statsNumber: number; text: string }) => {
  return (
    <div className="flex w-[150px] flex-col">
      <div className="lg:text-title-1 text-title-4 font-black">{statsNumber}+ </div>
      <div className="text-title-6 font-medium">{text}</div>
    </div>
  );
};
export const SurgicalAssistance = () => {
  const { isLg } = useWindowWidth();
  return (
    <>
      <NextSeo
        title="Surgical Assistance | PrishaPolicy"
        description="Now avail affordable medical services with PrishaPolicy's exclusive tie-up with Pristyn Care"
      />
      <ProductMain color="teal">
        <HeroBackground backgroundColor="teal-300" padding={false}>
          <div className="container grid w-full pt-24 lg:pt-32 xl:grid-cols-2">
            <div className="lg:text-left">
              <h1 className="font-bold" style={{ fontSize: isLg ? 60 : 32 }}>
                Consult expert surgeons for 50+ diseases
              </h1>
              <div className="text-title-7 mt-2">
                Now avail affordable medical services with PrishaPolicy&apos;s exclusive tie-up with Pristyn Care
              </div>
              <div className="mt-5 flex flex-col gap-3 lg:flex-row">
                <Button
                  text="Schedule a Free Consultation"
                  rightIcon="arrowRight"
                  size="medium"
                  onClick={() => window.open(pristynLink)}
                />
                <Button
                  text="Schedule a Second Opinion"
                  rightIcon="arrowRight"
                  variant="secondary"
                  size="medium"
                  onClick={() => window.open(pristynLink)}
                />
              </div>
              <div className="mt-5 ">Trusted By</div>
              <div className="flex pb-12">
                <Stats statsNumber={400} text="Doctors" />
                <Stats statsNumber={40} text="Cities" />
              </div>
            </div>
            <div className="hidden items-end lg:flex">
              <Image src={HeroImage} alt="HeroImage" />
            </div>
          </div>
        </HeroBackground>
        <div className="container">
          <WhoChoosesThis />
          <MedicalServices />
        </div>
        <Consultation />
      </ProductMain>
    </>
  );
};

export default SurgicalAssistance;
